import React, { Children, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SettingsIcon from "@mui/icons-material/Settings";

// import JS files
import { useUserData } from "../../context/UserDataContext";
import AdminSideBar from "../admin-panels/shares/AdminSideBar";
import CustomerSideBar from "../customer-panels/shares/CustomerSideBar";

import PanelDrawer from "./PanelDrawer";
import ProducerSideBar from "../producer-panels/shares/ProducerSideBar";
import MuiDropDown from "./MuiDropDown";
import EmployeeSideBar from "../employee-panels/shares/EmployeeSideBar";

// import Others files

const PanelTemplate = ({ children, sidebarActiveLink }) => {
  let windowWidth = window.screen.width;
  const { userData } = useUserData();

  const [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawer = () => {
    setOpenDrawer((before) => !before);
  };

  return (
    <>
      {/* Desktop Navbar Part */}
      <div className="hidden bg-myblue-100 px-8 py-1 md:block fixed top-0 overflow-hidden w-screen z-10">
        {userData.job == "Admin" ? (
          <AdminSideBar activeLink={sidebarActiveLink} />
        ) : userData.job == "Customer" ? (
          <CustomerSideBar activeLink={sidebarActiveLink} />
        ) : userData.job == "Employee" ? (
          <EmployeeSideBar activeLink={sidebarActiveLink} />
        ) : (
          <ProducerSideBar activeLink={sidebarActiveLink} />
        )}
      </div>
      {/* End Desktop Navbar Part */}
      {/* Mobile Navbar Part */}
      <div className=" md:hidden bg-myblue-100 shadow fixed w-screen z-10 py-3 px-3 flex justify-between items-center">
        <MenuIcon
          fontSize="large"
          className="text-yellow-200 font-bold"
          onClick={() => toggleDrawer()}
        />
        <span className="font-bold text-yellow-200 text-lg">فروشگاه زرسان</span>
      </div>
      {/* End Mobile Navbar Part */}
      <div className="py-20 px-4 md:py-8 md:px-8">{children}</div>
      <PanelDrawer
        anchor="right"
        openDrawer={openDrawer}
        setOpenDrawer={setOpenDrawer}
      >
        {userData.job == "Admin" ? (
          <div className="bg-myblue-100 w-full px-6 py-4">
            <AdminSideBar activeLink={sidebarActiveLink} />
          </div>
        ) : userData.job == "Customer" ? (
          <div className="bg-myblue-100 md:h-full w-full px-6 py-4">
            <CustomerSideBar activeLink={sidebarActiveLink} />
          </div>
        ) : (
          <div className="bg-myblue-100 md:h-full w-full px-6 py-4">
            <ProducerSideBar activeLink={sidebarActiveLink} />
          </div>
        )}
      </PanelDrawer>
    </>
  );
};

export default PanelTemplate;
